import { FC, ReactNode } from 'react';

import { CloseButton } from '@telialt/common-button/src';
import { DataTest } from '@telialt/utils/src/helpers';

import Modal, { Types } from './Modal';
import { HeaderFooter, HeaderTitle } from './ModalExtended.styles';
import { ModalSize } from './model';
import { MODAL_TEST_ID } from './test-ids';

type Props = {
    title?: ReactNode;
    subTitle?: ReactNode;
    footer?: ReactNode;
    type?: Types | Types[];
    isShown?: boolean;
    className?: string;
    isCloseButton?: boolean;
    titleClassName?: string;
    headerClassName?: string;
    bodyClassName?: string;
    isScrollable?: boolean;
    children?: ReactNode;
    onHide?: () => void;
    loaderContent?: ReactNode;
} & DataTest;

export const ModalExtended: FC<Props> = ({
    isShown,
    onHide,
    footer,
    type,
    title,
    subTitle,
    className,
    isCloseButton,
    titleClassName,
    headerClassName,
    bodyClassName,
    isScrollable,
    children,
    dataTest,
    loaderContent,
}) => {
    const headerContent =
        isCloseButton || title || subTitle ? (
            <HeaderFooter>
                {isCloseButton && <CloseButton onClick={onHide} />}
                <div className={headerClassName}>
                    <HeaderTitle className={titleClassName} data-test={MODAL_TEST_ID.TITLE}>
                        {title}
                    </HeaderTitle>
                    {subTitle && <div data-test={MODAL_TEST_ID.SUBTITLE}>{subTitle}</div>}
                </div>
            </HeaderFooter>
        ) : undefined;

    const footerContent = footer && <HeaderFooter>{footer}</HeaderFooter>;

    const size = type === 'wide' || (Array.isArray(type) && type.includes('wide')) ? ModalSize.Xl : undefined;

    return (
        <Modal
            isShown={isShown}
            onHide={onHide}
            header={headerContent}
            footer={footerContent}
            className={className}
            bodyContentClassName={bodyClassName}
            isScrollable={isScrollable}
            type={type}
            size={size}
            dataTest={dataTest}
            loaderContent={loaderContent}
        >
            {children}
        </Modal>
    );
};
